import {CUSTOMER_DETAILS_SERVICE_NAME} from "../../../utils/names/serviceNames";

export class CoBorrowerController {

    static instance = {
        controller: ['$scope', CUSTOMER_DETAILS_SERVICE_NAME, CoBorrowerController],
        template: require("./borrower_coborrowers_tab.html"),
        bindings: {
            "customer": "<"
        }
    };

    constructor($scope, CustomerDetailService) {
        this.$scope = $scope;
        $scope.message = "Here I go!!";
        $scope.coborrowersLoaded = false;
        $scope.coborrowers = [];
        this.CustomerDetailService = CustomerDetailService;
    }

    $onInit() {
        this.CustomerDetailService.getCustomerCoborrowers(this.customer.id,
            (resp) => {
                if (resp.status === 200) {
                    let uniqueCustomers = {};
                    resp.data
                        .reduce((accumulator, customers) => accumulator.concat(customers), [])
                        .filter(c => c.id !== this.customer.id)
                        .forEach((c) => uniqueCustomers[c.id] = c);
                    let coborrowers = Object.values(uniqueCustomers);
                    coborrowers.forEach(c => c.createdAt = new Date(c.createdAt));
                    this.$scope.coborrowers = coborrowers;
                    this.$scope.coborrowersLoaded = true;
                }
            },
            (error) => {
                console.log(error);
            })
    }
}
